import { NavLink } from 'react-router';
import useLayoutPermission from '@src/hooks/useLayoutPermission';
import { ConfigFeature } from '@src/types/LayoutPermission';
import storeConnector from '@store/storeConnector';
import { SiteMeta } from '@src/types/SiteMeta';

const configNavItems: Array<{
  title: string;
  feature: ConfigFeature;
  link: string;
}> = [
  {
    title: 'Control Mode Templates',
    feature: 'mode-templates',
    link: 'mode-templates',
  },
  {
    title: 'Calendar',
    feature: 'calendar',
    link: 'calendar',
  },
  {
    title: 'Calendar Stacks',
    feature: 'stack',
    link: 'stacks',
  },
  {
    title: 'Default Stack',
    feature: 'default-stack',
    link: 'default-stack',
  },
];

interface TopBarProps {
  siteMeta: SiteMeta;
}

function TopBar({ siteMeta }: TopBarProps) {
  const { configFeatures } = useLayoutPermission();
  const isCalendarEnabled = siteMeta?.ui?.Home_Calendar_Enable !== false;

  // Filter items based on calendar enable flag
  const visibleItems = configNavItems.filter((item) => {
    // When calendar is disabled, only show Control Mode Templates and Default Stack
    if (!isCalendarEnabled) {
      return (
        item.feature === 'mode-templates' || item.feature === 'default-stack'
      );
    }
    return true;
  });

  return (
    <div className='topbar'>
      <div className='frame'>
        {visibleItems.map(({ feature, title, link }) =>
          configFeatures.includes(feature) ? (
            <NavLink
              key={feature}
              title={title}
              to={`/home/config-beta/${link}`}
              className={({ isActive }) => `link ${isActive ? 'active' : ''}`}
            >
              {title}
            </NavLink>
          ) : null,
        )}
      </div>
    </div>
  );
}

export default storeConnector(TopBar, {
  config: ['siteMeta'],
});
